/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ points: NonNullable<unknown> }} Orders_Carrier_Points_CreditedInputs */

const en_orders_carrier_points_credited = /** @type {(inputs: Orders_Carrier_Points_CreditedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.points} reward points credited to customer.`)
};

const es_orders_carrier_points_credited = /** @type {(inputs: Orders_Carrier_Points_CreditedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Se acreditaron ${i?.points} puntos de recompensa al cliente.`)
};

/**
* | output |
* | --- |
* | "{points} reward points credited to customer." |
*
* @param {Orders_Carrier_Points_CreditedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_carrier_points_credited = /** @type {((inputs: Orders_Carrier_Points_CreditedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Carrier_Points_CreditedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_carrier_points_credited(inputs)
	return es_orders_carrier_points_credited(inputs)
});